import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../../components/componentsGeneral/AnimatedView/AnimatedView';
import BarcodeScanningContainer from '../../../../components/componentsInventoryManagement/_Lot_Tracking_Components/BarcodeScanning/BarcodeScanningContainer';
import { Message } from 'rsuite';
import { lotTrackingWarehouseIDs } from '../../../../app/appConfig';

class invManBarcodeScanningView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
    }

    render() {

        // if (this.props.warehouseSelection !== 1 && this.props.warehouseSelection !== 8 && this.props.warehouseSelection !== 9) {
        if (!lotTrackingWarehouseIDs.includes(this.props.warehouseSelection) && !lotTrackingWarehouseIDs.includes("All")) {

            return <AnimatedView><Message style={{ marginTop: '25px' }} type="info" description="Please only select Lot Tracking warehouses" /></AnimatedView>;
        }
    
        if (typeof this.props.customerSelection !== 'number') {
            return <AnimatedView><Message style={{ marginTop: '25px' }} type="info" description="Please select one customer" /></AnimatedView>;
        }
    
        return (
            <AnimatedView>
                <BarcodeScanningContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection} />
            </AnimatedView>

        );
    }
}

export default invManBarcodeScanningView;
